<template>
  <header>
    <div class="profile">
      <div class="avatar">
        <img src="https://cdn.discordapp.com/avatars/268758715014971392/47431b88cdb8b93ca1cb1c79868a50a9.png?size=64" />
      </div>
      <div class="username">Tiniel Cerulis</div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
}
</script>
